export const GetFormattedDate = (text, record) => {
  if (!text) {
    return "";
  }

  const _getMonth = (currMonth) => {
    switch (Number(currMonth)) {
      case 1:
        return "JAN";
      case 2:
        return "FEB";
      case 3:
        return "MAR";
      case 4:
        return "APR";
      case 5:
        return "MAY";
      case 6:
        return "JUN";
      case 7:
        return "JUL";
      case 8:
        return "AUG";
      case 9:
        return "SEP";
      case 10:
        return "OCT";
      case 11:
        return "NOV";
      case 12:
        return "DEC";
      default:
        return "";
    }
  };

  // const month = getUTCformattedMonth(date)
  //console.log(text.split("-"))
  const year = text.split("-")[0];
  const day = text.split("-")[2];
  const month = _getMonth(text.split("-")[1]);

  return `${day} ${month} ${year}`;
};

export const GetFormattedDateTime = (text, passTime = false) => {
  if (!text) return "";

  const dateObj = new Date(text);
  if (isNaN(dateObj)) return "";

  const day = String(dateObj.getDate()).padStart(2, "0");

  // Capitalize only the first letter of the month
  const monthRaw = dateObj.toLocaleString("en-US", { month: "short" });
  const month =
    monthRaw.charAt(0).toUpperCase() + monthRaw.slice(1).toLowerCase();

  const year = dateObj.getFullYear();

  let formatted = `${day} ${month} ${year}`;

  if (passTime === true) {
    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert to 12-hour format
    formatted += ` ${hours}:${minutes} ${ampm}`;
  }

  return formatted;
};

export const GetSpacedSpan = (text) => {
  if (!text) return "";
  return <div className="givePadding">{text}</div>;
};
